module.exports = __webpack_public_path__ + "static/devup2017-16ec531033ff47d04f5d6813b0bd8820.jpeg";